import { uid } from "@ht/shared/methods";

import { Socket, connect as io } from "socket.io-client";

import { Middleware } from "redux";
import {
  callSocketOpened,
  callSocketClosed,
  callIncomingMessageReceived,
  callSetAvailable,
  billingIncomingMessageReceived,
  callSetUniqueDeviceId,
  callTranscriptRefreshData,
  aiSummarizationRefreshData,
} from "./callSlice";
import validJson from "../../utils/validJson";

const callMiddleware: Middleware = (store) => {
  let socket: Socket;
  let tries = 0;
  let uniqueDeviceId = "";

  const initConnection = () => {
    const { user } = store.getState().auth;
    const url = process.env.REACT_APP_WSCN_ADDRESS ?? "";
    const domain = new URL(url);
    const pathname = "/wss/call-notification/";
    const cleandomain = `${domain.protocol}//${domain.hostname}:${domain.port}`;
    const userid = user?.userId;
    const username = user?.username;
    uniqueDeviceId = `${user?.deviceId}${uid(4)}`;

    if (uniqueDeviceId) {
      if (socket) socket.disconnect()
      socket = io(cleandomain, {
        path: pathname,
        transports: ["websocket", "polling", "flashsocket"],
        query: {
          device_id: uniqueDeviceId,
          user_id: userid,
          username: username,
          domain: window.location.host,
        },
      });

      socket.on("disconnect", () => {
        console.log("disconnecting from call notification server");
        store.dispatch(callSocketClosed());
        store.dispatch(callSetAvailable(false));
      });

      socket.on("connect", () => {
        store.dispatch(callSocketOpened());
        store.dispatch(callSetAvailable(true));
        store.dispatch(callSetUniqueDeviceId(uniqueDeviceId));
        tries = 0;
      });
      socket.on("update-transcript-data", (data: any) => {
        console.log("CALLTRANSCRIPT ==> ", data);
        store.dispatch(callTranscriptRefreshData(data));
      });
      socket.on("update-aisummarization-data", (data: any) => {
        console.log("AISUMMARIZATION ==> ", data);
        store.dispatch(aiSummarizationRefreshData(data));
      });
      socket.on("message", (receivedMessage: any) => {
        console.log("MESSAGE ==> ", receivedMessage);
        if (!validJson(receivedMessage)) return;

        const data = JSON.parse(receivedMessage);

        if (data.msg_type === "BILLING") {
          console.log(
            "BILLING ==> dispatch billingIncomingMessageReceived",
            data
          );
          store.dispatch(billingIncomingMessageReceived(data));
        } else {
          store.dispatch(callIncomingMessageReceived(data));
        }
      });

      socket.on("error", (e: any) => {
        console.log("error connecting", tries, e);
        tries++;
        store.dispatch(callSetAvailable(false));
      });
    }
  };

  return (next) => (action) => {
    const actionString = action.type.toString().split("/")[1];

    switch (actionString) {
      case "callWSStartConnecting":
        initConnection();
        break;
      case "setAvailable":
        tries = 0;
        break;
      case "callWSDisconnect":
        socket?.close();
        socket?.disconnect();
        break;
      case "callSendMessage":
        try {
          socket.emit("message", { content: action.payload.content });
        } catch (e) {
          console.log("ERROR", e);
        }
        break;
    }
    next(action);
  };
};

export default callMiddleware;
